import FadeIn from "@/components/FadeIn";
import { BadgeCheck, Star } from "lucide-react";

const AVIS = [
  {
    initiales: "VL",
    nom: "Valérie L.",
    lieu: "Rue Lepic, Paris 18e",
    texte: "Estimation remise en vingt-quatre heures, documentée rue par rue. Le prix annoncé était le prix signé.",
    detail: "Appartement vendu · 2026",
  },
  {
    initiales: "MD",
    nom: "Marc D.",
    lieu: "Avenue Junot, Paris 18e",
    texte: "Discrétion absolue, acquéreurs qualifiés, zéro visite inutile. Une exigence rare dans ce métier.",
    detail: "Maison vendue · 2026",
  },
  {
    initiales: "HR",
    nom: "Hélène R.",
    lieu: "Neuilly-sur-Seine",
    texte: "Du premier appel à la signature, tout était limpide. Le rapport d'estimation a convaincu toute la famille.",
    detail: "Appartement vendu · 2025",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="avis" data-testid="testimonials-section" className="mx-auto max-w-7xl px-6 py-24 lg:py-32">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">Ils ont vendu</p>
        <h2 className="font-display mt-4 max-w-2xl text-2xl font-normal tracking-tight text-amber-100 sm:text-3xl lg:text-4xl">
          La confiance de ceux qui nous ont confié <em className="text-[#D4AF37]">leur bien.</em>
        </h2>
      </FadeIn>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {AVIS.map((a, i) => (
          <FadeIn key={a.nom} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-${i}`}
              className="flex h-full flex-col justify-between border border-stone-800 bg-[#141417] p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
            >
              <div>
                <div className="flex items-center gap-1" aria-label="5 étoiles sur 5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={14} className="fill-[#D4AF37] text-[#D4AF37]" />
                  ))}
                </div>
                <blockquote className="font-display mt-5 text-lg italic leading-relaxed text-stone-200">
                  « {a.texte} »
                </blockquote>
              </div>
              <figcaption className="mt-8 flex items-center gap-4 border-t border-stone-800/60 pt-6">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#D4AF37]/40 font-display text-sm text-[#E5C158]">
                  {a.initiales}
                </span>
                <div>
                  <p className="text-sm text-stone-200">{a.nom}</p>
                  <p className="text-xs text-stone-500">{a.lieu}</p>
                  <p className="mt-1 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-emerald-400">
                    <BadgeCheck size={12} /> {a.detail} — vente vérifiée
                  </p>
                </div>
              </figcaption>
            </figure>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
